import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'

import foretag from '../src/foretag.png'
import hwj from '../src/hwj2.png'
import ipw from '../src/impressive-watches.webp'
import jcwatches from '../src/jcwathes.png'
import Chronos from '../src/777chronos.png'
import luxurywatches from '../src/luxurywatches-logo.svg'
import klocksalongen from '../src/klocksalongen.avif'
import careofcarl from '../src/careofcarl.svg'

const navigation = [
  { name: 'Kronos köpskydd', href: '/kronos-secure' },
  { name: 'Kronos Certified', href: '/kronos-certified' },
  { name: 'Kontrollera certifiering', href: '/kronos-certified-control' },
  { name: 'Klockvärdering', href: '/klockvardering' },
  { name: 'Företagsannonsering', href: '/foretagsannonsering' },
  { name: 'Marknadsföring', href: '/marknadsforing' },
  { name: 'Blogg', href: '/blogg' },
  { name: 'Integritetspolicy', href: '/integritetspolicy' },
  { name: 'Användarvillkor', href: '/anvandarvillkor' },
]

const companyLogos = [
  { logo: luxurywatches, name: 'Luxury Watches' },
  { logo: careofcarl, name: 'Care of Carl' },
  { logo: ipw, name: 'Impressive Watches' },
  { logo: hwj, name: 'HWJ' },
  { logo: Chronos, name: 'Chronos' },
  { logo: jcwatches, name: 'JC Watches' },
  { logo: klocksalongen, name: 'Klocksalongen' },
]

function Foretag({ siteLogo }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Header retained */}
      <header className="fixed inset-x-0 top-0 z-50 bg-white shadow">
        <nav className="flex items-center justify-between p-6 lg:px-8">
          <a href="/" className="flex items-center -m-1.5 p-1.5">
            <span className="sr-only">Krono</span>
            <img alt="Krono Logo" src={siteLogo} className="h-6 w-auto rounded-md" />
          </a>

          <div className="flex lg:hidden">
            <button
              type="button"
              className="p-2.5 text-gray-700 rounded-md"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>

          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-semibold text-gray-900 hover:underline"
              >
                {item.name}
              </a>
            ))}
          </div>
        </nav>

        {/* Mobile menu */}
        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full max-w-sm bg-white px-6 py-6 overflow-y-auto shadow-lg">
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="p-2.5 text-gray-700 rounded-md"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 space-y-2">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      <main>
        {/* Hero */}
        <section className="relative isolate overflow-hidden bg-white">
          <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-14 sm:px-8 sm:py-20 lg:grid-cols-2 lg:px-10 lg:py-24">
            <div className="text-left">
              <span className="inline-flex items-center gap-2 rounded-full border border-blue-100 bg-white/90 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-blue-700 shadow-sm">
                För handlare
              </span>
              <h1 className="mt-6 max-w-2xl font-poppins text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl lg:text-6xl">
                Annonsera som företag på Kronos
              </h1>
              <p className="mt-6 max-w-xl text-lg leading-8 text-slate-600">
                Nå ut till engagerade klockentusiaster på en marknadsplats byggd för klockor. Skapa
                en egen butikssida och visa upp ert sortiment för en relevant målgrupp.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href="mailto:info@kronos.se"
                  className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-6 py-3.5 text-sm font-semibold text-white shadow-lg shadow-blue-600/20 transition hover:-translate-y-0.5 hover:bg-blue-700"
                >
                  Anslut ert företag{' '}
                  <span aria-hidden="true" className="ml-2">
                    →
                  </span>
                </a>
                <a
                  href="#sa-kommer-ni-igang"
                  className="inline-flex items-center justify-center rounded-xl border border-slate-200 bg-white px-6 py-3.5 text-sm font-semibold text-slate-800 transition hover:border-blue-200 hover:bg-blue-50"
                >
                  Så fungerar det
                </a>
              </div>
              <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-600">
                <span className="inline-flex items-center gap-2">
                  <span className="text-blue-600">✓</span> Egen butikssida
                </span>
                <span className="inline-flex items-center gap-2">
                  <span className="text-blue-600">✓</span> Klockintresserad målgrupp
                </span>
                <span className="inline-flex items-center gap-2">
                  <span className="text-blue-600">✓</span> Kostnadsfri anslutning
                </span>
              </div>
            </div>
            <div className="relative mx-auto w-full max-w-xl">
              <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-blue-100 to-slate-100 blur-xl" />

              <div className="relative mx-auto w-full max-w-md lg:max-w-lg">
                <div className="absolute -inset-3 rounded-3xl " />
                <div className="relative mx-auto w-full max-w-lg lg:max-w-xl">
                  <div className="absolute -inset-4 rounded-3xl " />

                  <div className="relative overflow-hidden rounded-2xl border border-slate-100 bg-white p-3 shadow-xl shadow-slate-900/5">
                    <img
                      src={foretag}
                      alt="Exempel på företagsannonser och butikssida på Kronos"
                      className="mx-auto max-h-[400px] w-full rounded-xl object-contain sm:max-h-[460px] lg:max-h-[500px]"
                    />

                    <div className="absolute bottom-5 left-5 right-5 rounded-xl border border-white/80 bg-white/95 p-3 shadow-md backdrop-blur-sm sm:bottom-6 sm:left-6 sm:right-6">
                      <p className="text-xs font-bold uppercase tracking-wider text-blue-700">
                        Kronos för företag
                      </p>
                      <p className="mt-1 text-sm font-semibold text-slate-900 sm:text-base">
                        Synlighet där klockintresset finns.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="mx-auto max-w-7xl px-6 py-14 sm:px-8 lg:px-10 lg:py-16">
          <div className="grid gap-4 md:grid-cols-3">
            {[
              {
                number: '01',
                title: 'En nischad målgrupp',
                text: 'Presentera era klockor för personer som redan är intresserade av klockor.',
              },
              {
                number: '02',
                title: 'Egen butikssida',
                text: 'Ge kunderna en tydlig plats att upptäcka ert företag och ert sortiment.',
              },
              {
                number: '03',
                title: 'Enkel anslutning',
                text: 'Skicka in era företagsuppgifter så hjälper vi er vidare.',
              },
            ].map((item) => (
              <div
                key={item.number}
                className="group rounded-2xl border border-slate-200/80 bg-white p-6 transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl hover:shadow-blue-900/5 sm:p-7"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-sm font-bold text-blue-700">
                  {item.number}
                </span>
                <h2 className="mt-5 text-lg font-semibold text-slate-950">{item.title}</h2>
                <p className="mt-2 leading-7 text-slate-600">{item.text}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Onboarding */}
        <section id="sa-kommer-ni-igang" className="bg-slate-50 py-16 sm:py-20">
          <div className="mx-auto grid max-w-7xl gap-12 px-6 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:px-10">
            <div className="max-w-lg text-left">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-700">
                Kom igång
              </p>
              <h2 className="mt-4 font-poppins text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
                Så här kommer ni igång
              </h2>
              <p className="mt-5 text-lg leading-8 text-slate-600">
                Det är enkelt att ansluta ert företag till Kronos. Maila oss uppgifterna nedan så
                hjälper vi er vidare.
              </p>
              <div className="mt-8 rounded-2xl border border-blue-100 bg-white p-5 shadow-sm">
                <p className="text-sm font-semibold text-slate-700">Skicka era uppgifter till</p>
                <a
                  href="mailto:info@kronos.se"
                  className="mt-2 inline-flex text-xl font-semibold text-blue-700 hover:text-blue-800 hover:underline"
                >
                  info@kronos.se
                </a>
              </div>
            </div>
            <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm sm:p-9">
              <h3 className="text-xl font-semibold text-slate-950">Uppgifter vi behöver</h3>
              <p className="mt-2 text-sm leading-6 text-slate-500">
                Förbered följande information i ert mejl.
              </p>
              <ul className="mt-7 grid gap-4 sm:grid-cols-2">
                {[
                  'Organisationsnummer',
                  'E-postadress',
                  'Telefonnummer',
                  'Telefon till er kontaktperson',
                  'Företagets logotyp',
                  'Besöksadress',
                  'Webbplats',
                  'Öppettider (vardagar och helger)',
                ].map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-3 rounded-xl bg-slate-50 px-4 py-3.5 text-sm font-medium text-slate-700"
                  >
                    <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-700">
                      ✓
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Automated advertising */}
        <section className="mx-auto max-w-7xl px-6 py-16 sm:px-8 sm:py-20 lg:px-10">
          <div className="overflow-hidden rounded-[2rem] border border-blue-100 bg-gradient-to-br from-blue-50 via-white to-slate-50 shadow-sm">
            <div className="grid gap-10 p-6 sm:p-10 lg:grid-cols-[1fr_0.9fr] lg:p-14">
              <div className="text-left">
                <span className="inline-flex rounded-full border border-blue-100 bg-white px-3 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-blue-700">
                  Annonsering automatiskt
                </span>
                <h2 className="mt-5 font-poppins text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
                  Automatisera er annonsering på Kronos
                </h2>
                <p className="mt-5 text-lg leading-8 text-slate-600">
                  Styr era annonser direkt från er egen webbplats och låt ert sortiment uppdateras
                  automatiskt på Kronos.
                </p>
                <ul className="mt-7 space-y-3">
                  {[
                    'Allt sköts via er befintliga webbplats',
                    'Automatiska annonser på Kronos',
                    'Mindre manuell administration',
                  ].map((item) => (
                    <li key={item} className="flex items-start gap-3 text-slate-700">
                      <span className="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-blue-700">
                        ✓
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="mailto:info@kronos.se?subject=Automatisk%20annonsering%20p%C3%A5%20Kronos"
                  className="mt-8 inline-flex items-center justify-center rounded-xl bg-blue-600 px-6 py-3.5 font-semibold text-white shadow-lg shadow-blue-600/20 transition hover:-translate-y-0.5 hover:bg-blue-700"
                >
                  Fråga om automatisk annonsering{' '}
                  <span aria-hidden="true" className="ml-2">
                    →
                  </span>
                </a>
              </div>
              <div className="flex flex-col justify-center rounded-2xl border border-white bg-white/80 p-5 shadow-sm sm:p-7">
                <p className="text-center text-sm font-semibold text-slate-600">
                  Företag som använder vår automatiska annonsering
                </p>
                <div className="mt-6 grid grid-cols-2 gap-3 sm:gap-4">
                  {companyLogos.map(({ logo, name }) => (
                    <div
                      key={name}
                      className={`flex h-24 items-center justify-center rounded-xl border border-slate-100 bg-white p-4 transition hover:border-blue-200 hover:shadow-md ${name === 'Klocksalongen' ? 'col-span-2 sm:col-span-1' : ''}`}
                    >
                      <img
                        src={logo}
                        alt={`${name} logotyp`}
                        className={`max-h-14 max-w-full object-contain ${name === 'Klocksalongen' ? 'rounded-md bg-[#80011F] p-1' : ''}`}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="px-6 pb-20 sm:px-8 lg:px-10">
          <div className="mx-auto max-w-5xl rounded-3xl bg-slate-950 px-6 py-12 text-center text-white sm:px-12 sm:py-16">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-300">
              Bli en del av Kronos
            </p>
            <h2 className="mx-auto mt-4 max-w-2xl font-poppins text-3xl font-bold tracking-tight sm:text-4xl">
              Redo att visa upp ert företag?
            </h2>
            <p className="mx-auto mt-4 max-w-xl leading-7 text-slate-300">
              Kontakta oss så berättar vi mer om hur ert företag kan synas på Kronos.
            </p>
            <a
              href="mailto:info@kronos.se"
              className="mt-8 inline-flex items-center justify-center rounded-xl bg-white px-7 py-3.5 font-semibold text-slate-950 transition hover:bg-blue-50"
            >
              Kontakta oss{' '}
              <span aria-hidden="true" className="ml-2">
                →
              </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  )
}

export default Foretag
